"use client";
import {
  Heading,
  HomeRoomCard,
  Paragraph,
  SectionWithContainer,
} from "@/components";
import SliderSwip from "@/components/SliderSwip";
import { ArrowRightIcon, NextIcon, PrevIcon } from "@/icons/icons";
import Link from "next/link";
import { Navigation, Pagination } from "swiper/modules";

const RoomsSilder: React.FC<{
  title: string;
  description: string;
  subDescription: string;
  images: { src: string; alt: string }[];
}> = ({ title, description, subDescription, images }) => {
  return (
    <SectionWithContainer sectionClassName="">
      <div className="flex flex-col items-center justify-center gap-5">
        <Heading level={2} className="text-center text-primary uppercase font-medium heading4">
          {title}
        </Heading>
        <Paragraph className="text-center text-dark heading3 font-montaga">
          {description}
        </Paragraph>
        <div className="grid lg:grid-cols-3 grid-cols-1  gap-4 mt-4">
          <div className="flex flex-col col-span-1 max-md:order-2 justify-center gap-4">
            <Paragraph className="description1 text-[#262626]">
              {subDescription}
            </Paragraph>
            <Link
              href="/rooms"
              className="text-primary font-medium capitalize  py-3 px-6 flex items-center justify-center gap-2 hover:text-white hover:bg-primary hover:scale-x-105 active:scale-x-95
              transition-all duration-300 ease-in-out border border-primary  w-fit description1 "
            >
              View overview
              <span>
                <ArrowRightIcon />
              </span>
            </Link>
          </div>
          <div className="col-span-2 max-md:order-1 w-full relative">
            <SliderSwip
              data={images}
              modules={[Pagination, Navigation]}
              pagination={{
                type: "fraction",
                clickable: true,
                renderBullet: (index : number, className : string) => {
                  return `<span class="${className}">0${index + 1}</span>`;
                },
              }}
              navigation={{
                nextEl: ".home-room-next",
                prevEl: ".home-room-prev",
              }}
              slidesPerView={1.3}
              spaceBetween={5}
              breakpoints={{
                1024: {
                  slidesPerView: 1.3,
                  spaceBetween: 35,
                },
                768: {
                  slidesPerView: 1.3,
                  spaceBetween: 35,
                },
              }}
              classNameSwiper="h-full w-full roomsSilder"
              classNameSwiperSlide="h-full w-full pb-11"
            >
              {(item) => <HomeRoomCard {...item} />}
            </SliderSwip>
            <div className="flex items-center justify-center gap-4 absolute bottom-1 lg:right-28 z-10">
              <button
                className={` hover:scale-105 w-[2rem] aspect-square flex items-center justify-center disabled:text-primary active:scale-95 text-secondary home-room-prev`}
              >
                <PrevIcon />
              </button>
              <button
                className={`hover:scale-105 active:scale-95 w-[2rem] aspect-square flex items-center justify-center disabled:text-primary text-secondary home-room-next`}
              > 
                <NextIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    </SectionWithContainer>
  );
};

export default RoomsSilder;
